export default class Menu {

  constructor() {
    this.rootHtml = document.querySelector('html');

    // Setup menu
    this.menuToggle = document.querySelector('.menu-toggle');
    this.menuItems = document.querySelectorAll('.main-menu a');
    this.addEvents();
  }

  addEvents ()
  {
    // watch scroll
    this.watchScroll();

    // Toggle menu
    this.menuToggle.addEventListener('click', () => this.toggle());

    // Close on click
    this.menuItems.forEach(el => {
      el.addEventListener('click', (event) => {
        // event.preventDefault();
        this.hide(event);
      });
    }, this);
  }

  // Show-hide the menu
  toggle ()
  {
    this.rootHtml.classList.toggle('menu-on');
  }
  hide ()
  {
    this.rootHtml.classList.remove('menu-on');
  }

  // Function that watch for scroll
  watchScroll () {

    // prepare throttle
    const throttle = ( callback, limit = 30, context = this ) => {
      let
        wait = false,
        timeout;

      return ( ...args ) => {
        if ( !wait ) {
          callback.call( context, ...args );

          wait = true;
          clearTimeout( timeout );

          timeout = setTimeout( function () {
            wait = false;
          }, limit );
        }
      }
    };

    // events
    this.fixHeader();
    window.addEventListener("scroll", throttle(this.fixHeader, 50));
  }

  fixHeader () {
    if (window.scrollY >= 200) {
      this.rootHtml.classList.add('has-scrolled');
    } else {
      this.rootHtml.classList.remove('has-scrolled');
    }
  }

}
